import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { htmlEscape } from "lib/helpers"

// stats--not-active-apps on `app/views/stats/not_active_apps.haml`.
export default class extends Controller {
  static targets = ["table", "accountDetails"]

  static values = {
    accountInfoPath: { type: String, default: "/stats/account_info" },
    tableUrl: { type: String, default: "/stats/global/not_active_apps" },
  }

  connect() {
    if (!this.hasTableTarget) return
    this.#initDataTable()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
  }

  showAccountInfo(event) {
    event.preventDefault()
    const accountId = event.currentTarget.dataset.accountId
    if (!accountId) return

    $.get(`${this.accountInfoPathValue}/${accountId}`, (data) => {
      if (this.hasAccountDetailsTarget) this.accountDetailsTarget.innerHTML = data
      $("#account-info-modal").modal("show")
    })
  }

  #initDataTable() {
    this.dataTable = createTurboDataTable(this.tableTarget, {
      dom: "lrtip",
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: true,
      ajax: {
        url: this.tableUrlValue,
      },
      columnDefs: [
        {
          targets: 3,
          createdCell(cell, cellData, rowData) {
            $(cell).html(
              `<a href="#" data-account-id="${rowData[1]}" data-action="click->stats--not-active-apps#showAccountInfo">${htmlEscape(cellData)}</a>`,
            )
          },
        },
        {
          targets: [2, 3],
          sortable: false,
        },
      ],
    })
  }
}
